// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23gf_","rootMobile":"styles_rootMobile__1NJXJ"};